import { Injectable } from '@angular/core';
import type { Inputfiledsbase } from '../../../models/inputfiledsbase';
import { TextboxQuestion } from '../../../question-textbox';
import { of } from 'rxjs';
import { TextareaQuestion } from '../../../question-textarea';

@Injectable({
  providedIn: 'root',
})
export class WebsiteNameService {
  constructor() {}

  getWebsiteNameform() {
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'name',
        label: 'Website Name',
        required: true,
        order: 1,
      }),
      new TextareaQuestion({
        key: 'description',
        label: 'Description',
        required: true,
        order: 2,
      }),
      new TextboxQuestion({
        key: 'website_url',
        label: 'Website URL',
        required: true,
        order: 3,
        type: 'url',
        patterns: 'https?://.+',
        placeholder: 'URL must be complete (e.g., https://example.com).',
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
